<template>
  <div>

    <div class="page-title _with-btn pl-3 pr-3">
      <h1>
        Search Results for "{{ search_query }}":
      </h1>
      <div class="btn-wrapper">
        <div class="input-group">
          <div class="input-group-addon">
            <i class="fal fa-search"></i>
          </div>
          <input type="text" class="form-control" placeholder="Search..." v-model="search_query">
        </div>
      </div>
    </div>

      <div class="page-title pl-3 pr-3">
        <h1>
          Page Results
        </h1>
      </div>

      <div v-for="(pages, site_page_section) in site_page_results" v-if="!loading && site_page_results.length !== 0">
        <h2 class="pl-3 pr-3">
          {{ site_page_section }}
        </h2>
        <div class="landing-page-panels">
          <a v-for="page in pages" class="landing-page-panel" :href="page.link_url" v-if="!page.content_upload_link">
            <div class="box">
              <div class="image">
                <img :src="page.thumbnail_url">
              </div>
              <div class="content">
                <div class="title">
                  {{ page.label }}
                </div>
                <div class="description">
                  {{ page.description }}
                </div>
              </div>
            </div>
          </a>
          <form v-for="page in pages" class="landing-page-panel" method="POST" action="/downloads" v-if="page.content_upload_link">
            <input type="hidden" :value="csrfToken" name="_token">
            <input type="hidden" :value="`[${page.content_upload_types}]`" name="selected_content_upload_types">
            <button type="submit">
              <div class="box">
                <div class="image">
                  <img :src="page.thumbnail_url">
                </div>
                <div class="content">
                  <div class="title">
                    {{ page.label }}
                  </div>
                  <div class="description">
                    {{ page.description }}
                  </div>
                </div>
              </div>
            </button>
          </form>
        </div>
      </div>
      <template v-if="!loading && site_page_results.length === 0">
        <div class="box">
          <div class="box-content">
            <strong>
              No Results Found
            </strong>
          </div>
        </div>
      </template>

    <hr>

    <div class="page-title _with-btn pl-3 pr-3">
      <h1>
        News Results
      </h1>
      <div class="btn-wrapper">
        <a class="btn-primary" href="/news">
          View All News
        </a>
      </div>
    </div>

    <template v-if="!loading && news_post_results_total_count > 0">
      <div class="news-posts">
        <a class="news-post-wrapper" v-for="news_post in news_post_results" :href="`/news/${news_post.id}`">
          <div class="news-post">
            <div class="news-post-image">
              <img :src="`${$aws_bucket_url}${news_post.main_image_url}`">
            </div>
            <div class="news-post-content">
              <div class="title">
                <h1>{{ news_post.title }}</h1>
              </div>
              <div class="date">
                {{ news_post.formatted_publish_at }}
              </div>
              <div class="summary">
                {{ news_post.summary }}
              </div>
              <div class="footer">
                <a class="btn-primary _sm">Read More</a>
              </div>
            </div>
          </div>
        </a>
      </div>
      <template>
        <div class="pagination-bar wrapper mb-3 mt-3 pl-3 pr-3">
          <div class="row">
            <div class="col">
              <a @click.prevent="newsPrevPage()" v-if="news_post_results_current_page > 1" class="btn-default _sm"><i
                  class="fa fa-caret-left"></i></a>
              <a class="btn-default _sm">{{ news_post_results_current_page }} / {{ news_post_results_total_pages }}</a>
              <a @click.prevent="newsNextPage()" v-if="news_post_results_current_page < news_post_results_total_pages"
                 class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
            </div>
            <div class="col align-right">
              <div class="mt-1 mb-1">
                {{ news_post_results_total_count }} results found
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-if="!loading && news_post_results_total_count === 0">
      <div class="box">
        <div class="box-content">
          <strong>
            No Results Found
          </strong>
        </div>
      </div>
    </template>

    <hr>

    <div class="page-title _with-btn pl-3 pr-3">
      <h1>
        Download Results
      </h1>
      <div class="btn-wrapper">
        <a class="btn-primary" href="/downloads">
          View All Downloads
        </a>
      </div>
    </div>

    <template v-if="!loading && content_uploads_results_total_count > 0">
      <div class="technical-uploads-list">
        <div class="technical-uploads-list-item" v-for="content_upload in content_uploads_results">
          <div class="box _bordered">
            <div>
              <img :src="`${$aws_bucket_url}${content_upload.thumbnail_url}`" @error="imageFallbackIcon">
            </div>
            <div>
              <div class="technical-uploads-list-item-name"> {{ content_upload.name }}</div>
              <div class="pt-2">
                <a class="btn-primary" :href="`/downloads/view-file/${content_upload.id}`" v-if="content_upload.type === 'file'">
                  <strong>View</strong>
                </a>
                <a class="btn-primary" :href="`/downloads/view-video/${content_upload.id}`" v-if="content_upload.type === 'video'">
                  <strong>View</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template>
        <div class="pagination-bar wrapper mb-3 mt-3 pl-3 pr-3">
          <div class="row">
            <div class="col">
              <a @click.prevent="newsPrevPage()" v-if="content_uploads_results_current_page > 1" class="btn-default _sm"><i
                  class="fa fa-caret-left"></i></a>
              <a class="btn-default _sm">{{ content_uploads_results_current_page }} / {{ content_uploads_results_total_pages }}</a>
              <a @click.prevent="newsNextPage()" v-if="content_uploads_results_current_page < content_uploads_results_total_pages"
                 class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
            </div>
            <div class="col align-right">
              <div class="mt-1 mb-1">
                {{ content_uploads_results_total_count }} results found
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-if="!loading && content_uploads_results_total_count === 0">
      <div class="box">
        <div class="box-content">
          <strong>
            No Results Found
          </strong>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  props: [
    'initial_query'
  ],
  data() {
    return {
      search_query: '',
      news_post_results: [],
      content_uploads_results: [],
      site_page_results: [],
      news_post_results_current_page: 1,
      news_post_results_total_count: 0,
      news_post_results_total_pages: 0,
      content_uploads_results_current_page: 1,
      content_uploads_results_total_count: 0,
      content_uploads_results_total_pages: 0,
      loading: true,
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    };
  },
  mounted() {
    this.search_query = this.initial_query;
    this.search();
  },
  methods: {
    search: _.debounce(function () {
      this.loading = true;
      axios.post('/search/getSearchResults', {
        search_query: this.search_query,
        news_post_results_current_page: this.news_post_results_current_page,
        content_uploads_results_current_page: this.content_uploads_results_current_page,
        site_page_results_current_page: this.site_page_results_current_page,
      }).then((response) => {
        this.news_post_results = response.data.news_post_results.data;
        this.news_post_results_total_count = response.data.news_post_results.total;
        this.news_post_results_total_pages = response.data.news_post_results.last_page;

        this.content_uploads_results = response.data.content_uploads_results.data;
        this.content_uploads_results_total_count = response.data.content_uploads_results.total;
        this.content_uploads_results_total_pages = response.data.content_uploads_results.last_page;

        this.site_page_results = response.data.site_page_results;
        this.loading = false;
      });
    }, 500),
    newsPrevPage() {
      this.news_post_results_current_page = this.news_post_results_current_page - 1;
      this.search();
    },
    newsNextPage() {
      this.news_post_results_current_page = this.news_post_results_current_page + 1;
      this.search();
    },
    uploadsPrevPage() {
      this.content_uploads_results_current_page = this.content_uploads_results_current_page - 1;
      this.search();
    },
    uploadsNextPage() {
      this.content_uploads_results_current_page = this.content_uploads_results_current_page + 1;
      this.search();
    },
    imageFallbackIcon(event) {
      event.target.src = '/images/content-uploads-thumbnail-fallback-icon.png';
    },
  },
  watch: {
    search_query() {
      this.search();
    },
  },
};
</script>
